"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const backwardCompatibilityForProperties_1 = require("../../helpers/backwardCompatibilityForProperties");
const function_utils_1 = require("../../utils/function-utils");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const LinkConsts_1 = require("./LinkConsts");
require("./Link.scss");
const Link = (0, react_1.forwardRef)(({ className, componentClassName, href, text, rel, onClick, target, ariaLabelDescription, icon, iconPosition, id, ariaLabeledBy, disableNavigation, inheritFontSize, inlineText }, ref) => {
    const overrideClassName = (0, backwardCompatibilityForProperties_1.backwardCompatibilityForProperties)([className, componentClassName]);
    const isStart = iconPosition === LinkConsts_1.IconPosition.START;
    const onClickWrapper = (0, react_1.useCallback)((e) => {
        if (disableNavigation) {
            e.preventDefault();
        }
        onClick && onClick(e);
    }, [disableNavigation, onClick]);
    return ((0, jsx_runtime_1.jsxs)("a", Object.assign({ id: id, href: href, rel: rel, ref: ref, onClick: onClickWrapper, target: target, className: (0, classnames_1.default)("monday-style-link", overrideClassName, {
            "inherit-font-size": inheritFontSize,
            "inline-text": inlineText
        }), "aria-label": ariaLabelDescription, "aria-labelledby": ariaLabeledBy }, { children: [getIcon(isStart, icon, "monday-style-link--icon-start"), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "monday-style-link--text" }, { children: text })), getIcon(!isStart, icon, "monday-style-link--icon-end")] })));
});
function getIcon(shouldShow, icon, className) {
    if (!shouldShow)
        return;
    return (0, jsx_runtime_1.jsx)(Icon_1.default, { className: className, clickable: false, icon: icon, iconType: Icon_1.default.type.ICON_FONT });
}
Object.assign(Link, {
    position: LinkConsts_1.IconPosition,
    target: LinkConsts_1.LinkTarget,
    iconPositions: LinkConsts_1.IconPosition,
    targets: LinkConsts_1.LinkTarget
});
Link.defaultProps = {
    id: "",
    className: undefined,
    href: "",
    text: "",
    rel: "noreferrer",
    onClick: function_utils_1.NOOP,
    target: (_a = Link.targets) === null || _a === void 0 ? void 0 : _a.NEW_WINDOW,
    ariaLabelDescription: "",
    icon: "",
    iconPosition: (_b = Link.position) === null || _b === void 0 ? void 0 : _b.START,
    ariaLabeledBy: "",
    disableNavigation: false,
    inheritFontSize: false,
    inlineText: false
};
exports.default = Link;
